import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';
import { ListItem } from 'palette/List';
import { Toggle } from 'palette/Toggle';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslate } from '@common/Translations';
import { isFeatureActive } from '@helpers/index';
import { toggleMultipleFilters } from '../actions/filtersActions';
import { FAVORITES } from '../constants';
import { getAvailableInBrandGroup, isCustomBrandSelected } from '../helpers';

export function BrandsGroupsList({ brandGroupsData, brands, activeBrandIds }) {
    const dispatch = useDispatch();
    const translate = useTranslate();
    const config = useConfig();

    const isHighlightsFilterActive = isFeatureActive('PLT-40756-reactivate-highlighted-filter-in-brands', config);

    const toggleMultipleFiltersClick = (filters, toggle) => {
        dispatch(toggleMultipleFilters(filters, toggle));
    };

    return (
        brandGroupsData
            ?.filter(({ brandgroupId }) => {
                if (brandgroupId === FAVORITES) {
                    return true;
                }

                return isHighlightsFilterActive;
            })?.map(({ brandgroupId, brandIds }) => {
                const brandGroups = getAvailableInBrandGroup(brandIds, brands);
                const isBrandGroupSelected = isCustomBrandSelected(brandGroups, activeBrandIds);
                const name = brandgroupId === FAVORITES
                    ? translate('brandaz.favorites.label')
                    : translate(`listing.brandgroups.${brandgroupId}.label`);
                const filterClickHandler = debounce((event) => {
                    event.preventDefault();
                    toggleMultipleFiltersClick(brandGroups, isBrandGroupSelected);
                });

                return (
                    brandGroups.length > 0 && (
                        <ListItem
                            key={brandgroupId}
                            isActive={isBrandGroupSelected}
                            onClick={filterClickHandler}
                        >
                            <Toggle
                                id={name}
                                isChecked={isBrandGroupSelected}
                                label={name}
                                variant="checkbox"
                            />
                        </ListItem>
                    )
                );
            })
    );
}
